import { Component, OnInit } from '@angular/core';
import {FacebookService} from "../../facebook.service";

@Component({
  selector: 'app-facebook-api',
  templateUrl: './facebook-api.component.html',
  styleUrls: ['./facebook-api.component.scss']
})
export class FacebookApiComponent implements OnInit {

  constructor(private fbService: FacebookService){}
  ngOnInit(): void {
  }

  loginAndGetPageToken(): void {
    this.fbService.login().then(response => {
      const userId = response.authResponse.userID;
      this.fbService.getPageAccessToken(userId).then(pageTokens => {
        console.log('Page Access Tokens:', pageTokens);
      }).catch(error => {
        console.error('Error fetching page tokens:', error);
      });
    }).catch(error => {
      console.error('Login failed:', error);
    });
  }

  loginAndGetUserAccessToken(): void {
    this.fbService.loginUser().then(accessToken => {
      console.log('User Access Token: ', accessToken);
    }).catch(error => {
      console.error('Error during login: ', error);
    })
  }


  share(): void {
    this.fbService.share('https://www.example.com');
  }

  feed(): void {
    this.fbService.feed('https://www.youtube.com');
  }

  feed2(): void {
    this.fbService.feed2(
      'https://www.facebook.com',
      'Check out this site!',
      'An interesting page to look at.',
      'https://www.example.com/thumbnail.jpg'
    );
  }

}
